import axios from 'axios'
import store from '@/store'

export default {
  httpServer() {
    // console.log('process.env.VUE_APP_API_PATH', process.env.VUE_APP_API_PATH)
    let baseURL
    if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'devpro' || process.env.NODE_ENV === 'devip') {
      baseURL = window.location.protocol + process.env.VUE_APP_API_PATH
    } else {
      baseURL = window.location.protocol + '//' + window.location.host.split(':')[0] + '/tainetv2/'
    }
    return axios.create({
      baseURL: baseURL,
      // baseURL: (window.location.protocol != "https:" ? process.env.VUE_APP_API_PATH : process.env.VUE_APP_API_PATH_HTTPS),
      headers: {
        'accept': 'application/json',
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8;',
        'Authorization': `Basic ${store.state.users.custmain.token}`
      },
      transformRequest: [function (data) {
        // if (headers.accept) { console.log(headers.accept) }
        data.version = "1.34.0"
        // console.log('httpServer transformRequest ' + baseURL , data)
        return JSON.stringify(data)
      }]
    })
  },
  httpUploadFile() {
    // console.log('process.env.VUE_APP_API_PATH', process.env.VUE_APP_API_PATH)
    return axios.create({
      baseURL: process.env.VUE_APP_API_PATH,
      // baseURL: (window.location.protocol != "https:" ? process.env.VUE_APP_API_PATH : process.env.VUE_APP_API_PATH_HTTPS),
      headers: {
        'accept': 'application/json',
        'content-type': 'multipart/form-data;charset=UTF-8;',
        'Authorization': `Basic ${store.state.users.main.token}`
      },
      transformRequest: [function (data, headers) {
        // if (headers.accept) { console.log(headers.accept) }
        data.version = "1.34.0"
        return JSON.stringify(data)
      }]
    })
  },
  bookServer(controler, action) {
    return axios.create({
      baseURL: process.env.VUE_APP_API_PATH + 'model_tb/default.asp?controller=' + controler + '&action=' + action,
      // baseURL: (window.location.protocol != "https:" ? process.env.VUE_APP_API_PATH : process.env.VUE_APP_API_PATH_HTTPS) + 'model_tb/default.asp?controller=' + controler + '&action=' + action,
      headers: {
        'accept': 'application/json',
        'content-type': 'application/x-www-form-urlencoded',
        'Authorization': `Basic ${store.state.users.main.token}`
      },
      transformRequest: [function (data, headers) {
        // if (headers.accept) { console.log(headers.accept) }
        data.version = "1.34.0"
        return JSON.stringify(data)
        // return data
      }]
    })
  },
  ItIsoServer(controler, action) {
    return axios.create({
      // baseURL: (window.location.protocol != "https:" ? process.env.VUE_APP_API_PATH : process.env.VUE_APP_API_PATH_HTTPS) + 'itiso/default.asp?controller=' + controler + '&action=' + action,
      baseURL: process.env.VUE_APP_API_PATH + 'itiso/default.asp?controller=' + controler + '&action=' + action,
      headers: {
        'accept': 'application/json',
        'content-type': 'application/x-www-form-urlencoded',
        'Authorization': `Basic ${store.state.users.main.token}`
      },
      transformRequest: [function (data, headers) {
        // if (headers.accept) { console.log(headers.accept) }
        data.version = "1.34.0"
        return JSON.stringify(data)
        // return data
      }]
    })
  },
  AssetServer(controler, action) {
    return axios.create({
      // baseURL: (window.location.protocol != "https:" ? process.env.VUE_APP_API_PATH : process.env.VUE_APP_API_PATH_HTTPS) + 'Asset/default.asp?controller=' + controler + '&action=' + action,
      baseURL: process.env.VUE_APP_API_PATH + 'Asset/default.asp?controller=' + controler + '&action=' + action,
      headers: {
        'accept': 'application/json',
        'content-type': 'application/x-www-form-urlencoded',
        'Authorization': `Basic ${store.state.users.main.token}`
      },
      transformRequest: [function (data, headers) {
        // if (headers.accept) { console.log(headers.accept) }
        data.version = "1.34.0"
        return JSON.stringify(data)
        // return data
      }]
    })
  },
  bookNoServer(controler, action) {
    return axios.create({
      // baseURL: (window.location.protocol != "https:" ? process.env.VUE_APP_API_PATH : process.env.VUE_APP_API_PATH_HTTPS) + 'model_tb/default.asp?controller=' + controler + '&action=' + action,
      baseURL: process.env.VUE_APP_API_PATH + 'model_tb/default.asp?controller=' + controler + '&action=' + action,
      headers: {
        'accept': 'application/json',
        'content-type': 'application/x-www-form-urlencoded',
        'Authorization': `Basic ${store.state.users.main.token}`
      },
      transformRequest: [function (data, headers) {
        // if (headers.accept) { console.log(headers.accept) }
        data.version = "1.34.0"
        return JSON.stringify(data)
        // return data
      }]
    })
  },
  httpFile() {
    return axios.create({
      // baseURL: (window.location.protocol != "https:" ? process.env.VUE_APP_API_PATH : process.env.VUE_APP_API_PATH_HTTPS) + 'api/Upload3/examples/FileSize_Save.asp',
      baseURL: process.env.VUE_APP_API_PATH + 'api/Upload3/examples/FileSize_Save.asp',
      headers: {
        'content-type': 'multipart/form-data ; charset=utf-8'
      }
    })
  }
}